import {creates, hoistCmp} from '@xh/hoist/core';
import {SectorMapWidgetModel} from './SectorMapWidgetModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {treeMap} from '@xh/hoist/cmp/treemap';

export const sectorMapWidget = hoistCmp.factory({
    model: creates(() => SectorMapWidgetModel),
    render({model}) {
        return panel({
            item: treeMap()
        });
    }
});
